import { handleResponse } from '../../Helpers/handle-response';
import * as apiHelper from '../../Helpers/apiHelper';


export function sendChangeCarrier(barcode,  previousCartID, newCartIDCartID, workflowID) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },

        body: JSON.stringify({
            barCode: barcode,
            previousCartID: previousCartID,
            newCartIDCartID:newCartIDCartID,
            workflowID:workflowID,
        })
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_SENDCHANGECARRIER);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}